<template>
  <div @click="$emit('click')" :key="order.id" :class="(!order.is_canceled && !order.is_confirmed) && 'bg-light-primary'" class="d-flex flex-column order-tender-item-block">
    <tender-card selectedType="all" @click="$router.push(`/timeless-tenders/sell/tender/${order.tender.id}`)" :tender="order.tender" />
    <div class="p-2">
      <div class="d-flex flex-column">
        <p class="text-secondary">Մատակարարման հասցե՝<span class="ml-2 font-weight-bold">{{order.delivery_address}}</span></p>
        <p class="text-secondary">Պատվիրված քանակ՝<span class="ml-2 font-weight-bold">{{order.count}}</span></p>
        <p class="text-secondary">Պատվերի ամբողջ գումարը՝<span class="ml-2 font-weight-bold price">{{order.total_amount}} դր</span></p>
        <p class="text-secondary">Պատվերի ամսաթիվը՝<span class="ml-2 font-weight-bold price">{{order.created_at}}</span></p>
        <p class="text-secondary" v-if="order.confirm_date">Պատվերի հաստատման ամսաթիվը՝<span class="ml-2 font-weight-bold price">{{order.confirm_date}}</span></p>
      </div>
      <div class="d-flex flex-column mt-2">
        <div class="d-flex">
          <div v-tooltip="hasContractHtml && 'Պահմանագրի նախագիծը հաստատված է'" class="actions-block">
            <button :disabled="hasContractHtml" @click="handleOpenContract" :class="hasContractHtml ? 'btn-primary' : 'btn-outline-primary'" class="btn հ-100">
              <span>Պայմանագիր</span>
            </button>
            <button v-if="order.buyer_signed_contract" class="btn-primary btn հ-100">
              <a download target="_blank"  :href="order.buyer_signed_contract" >
                <span class="text-white">Գնորդի ID-ով ստոր․ պայմանագիր</span>
              </a>
            </button>
            <button v-if="order.seller_signed_contract" class="btn-primary btn հ-100">
              <a download target="_blank"  :href="order.buyer_signed_contract" >
                <span class="text-white">Վաճառողի ID-ով ստոր․ պայմանագիր</span>
              </a>
            </button>
            <template v-if="!dontShowActions">
              <button v-if="!(order.is_confirmed || order.is_canceled)" @click="triggerFileInput" class="m-0 btn" :class="(signedContract) ? 'btn-primary' : 'btn-outline-primary'">
                <span>Կցել ID-ով ստոր․ պայմանագիր</span>
                <input ref="fileInput" @change="uploadSignedContract" type="file" hidden>
              </button>
            </template>
          <div class="mt-2">
            <span class="text-danger" v-if="order.is_canceled">Մերժված է</span>
            <span class="text-success" v-if="order.is_confirmed">Հաստատված է</span>
          </div>
          </div>
        </div>
        <template v-if="!dontShowActions">
          <div class="d-flex" v-if="!(order.is_confirmed || order.is_canceled)">
            <div class="h-100 mt-2" style="width: fit-content;" v-tooltip="(!hasContractHtml && !signedContract) && 'Հաստատեք պայմանգրի նախագիծը պատվերը հաստատելու համար'">
              <button @click="confirmOrder" style="height: 100%;" :disabled="!hasContractHtml && !signedContract" class="btn btn-primary հ-100">
                <span>Հաստատել</span>
              </button>
            </div>
            <div class="h-100 mt-2 ml-2" style="width: fit-content;" >
              <button @click="handleCancelOrder" style="height: 100%;" class="btn btn-primary հ-100">
                <span>Մերժել</span>
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script >
import TenderCard from '@/components/timelessTenders/tenderCard.vue';

export default {
  components: { TenderCard },
  props: ['order', 'canEdit', 'selectedType', 'hasContractHtml', 'dontShowActions'],
  data() {
    return {
      dateNow: new Date(),
      backendUrl: process.env.VUE_APP_URL,
      tenders: [],
      contractHtml: '',
      signedContract: '',
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    selectPage(event){
      this.$router.push(event.target.value)
    },
    confirmOrder(){
      this.$emit('handleConfirmOrder', {
        order: this.order,
      })
    },
    handleCancelOrder(){
      this.$emit('handleCancelOrder', {
        order: this.order,
      })
    },
    handleOpenContract(){
      this.$emit('handleOpenContract', {
        order: this.order,
      })
    },
    triggerFileInput() {
      // Trigger the hidden file input click
      this.$refs.fileInput.click();
    },
    async uploadSignedContract(event) {
      const file = event.target.files[0];
      this.contractHtmlFile = file;
      if (!file) {
        alert('Please select a file to upload.');
        return;
      }

      const formData = new FormData();
      formData.append('pdf_file', file);

      await this.$client.post('/check-signed-pdf', formData).then(({data}) => {
        if(data.isSigned){
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Հաջողությամբ հաստատված է'
          })
          this.signedContract = true;
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ինչ որ բան այն չէ, Կրկին փորձեք!'
          })
          this.signedContract = false;
        }
      });
    },
  },
}
</script>

<style scoped>
.text-secondary{
  font-size: 13px;
  span{
    font-size: 14px;
    color: #2D3036;
  }
}
.actions-block{
  flex-wrap: wrap;
  flex: auto;
  display: flex;
  gap: 10px;
  width: fit-content;
}
.order-tender-item-block .tender-item-block {
  width: 100% !important;
}
.order-tender-item-block {
  width: calc(100% / 4);
  border-radius: 6px;
}

.enlarge-menu .order-tender-item-block {
  width: calc(100% / 5);
}
.order-tender-item-block *{
  max-width: 100%;
}
.order-tender-item-block img{
  border-radius: 6px;
  height: 200px;
}
.order-tender-item-block p{
  border-radius: 6px;
}
.order-tender-item-block .price{
  font-size: 18px;
  font-weight: 600;
}

@media (max-width: 1324px) {
  .order-tender-item-block {
    width: calc(100% / 4) !important;
  }
}

@media (max-width: 1024px) {
  .order-tender-item-block {
    width: calc(100% / 3) !important;
  }
}

@media (max-width: 768px) {
  .order-tender-item-block {
    width: calc(100% / 2) !important;
  }
}

@media (max-width: 480px) {
  .order-tender-item-block {
    width: 100% !important;
  }
}
</style>

